module.exports = __webpack_public_path__ + "static/media/browser2.64f50dd1.svg";